// extracted by mini-css-extract-plugin
module.exports = {"fundsTable":"FundsTable_fundsTable__q5r_K","skeleton-row":"FundsTable_skeleton-row__HqOH7","scrollable":"FundsTable_scrollable__eSfP9"};